type Source =
    'https://gos.app.link/email'
    | 'https://simplepay24.app.link/fssp-app'
    | 'https://simplepayment.app.link/email'
    | string

export default function sourceServiceMap(source: Source) {
    switch (source) {
        case 'https://gos.app.link/email' :
            return 'Приложение "Госоплата"'
        case 'https://simplepay24.app.link/fssp-app' :
            return 'Приложение "ФССП"'
        case 'https://simplepayment.app.link/email' :
            return 'Приложение "ГИБДД"'
        default:
            return source
    }
}
